/**
 * External dependencies
 */
import React, { useState } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Button from 'components/button';
import { successNotice, errorNotice } from 'state/notices/actions';
import cecSdk from 'lib/customer-ec-sdk';
import JumpingDots from 'components/jumping-dots';

const TestWebhookOrderCreationButton = ({ connectionId, details, ...props }) => {
   
    const [testing, setTesting] = useState(false);
    const [hookResponse, setHookResponse] = useState(null);

    const testWebhookOrderCreation = async () => {
        setTesting(true);
        try {
            let hookResponse = await cecSdk.connection(connectionId).testBCWebhookOrderCreation({ connectionDetails: details });
            setHookResponse(hookResponse);

            if (hookResponse.status == 200) {
                props.successNotice(hookResponse.title);
            } else {
                props.errorNotice(hookResponse.title);
            }
        } catch (error) {
            props.errorNotice('Unknown error occoured.');

        }
        setTesting(false);
    };

    return (
        <Button disabled={testing} onClick={testWebhookOrderCreation}>
            {testing ? <div>Testing webhook connection <JumpingDots /></div> : 'Test webhook connection'}
        </Button>
    );

};

export default connect(null, {
    successNotice,
    errorNotice,
})(TestWebhookOrderCreationButton);
